import { AbstractSearchArgument } from './global'

class FormArgument extends AbstractSearchArgument {
  constructor () {
    super()
    this.name = ''
    this.enterpriseName = ''
    this.telephone = ''
    this.platform = ''
    this.type = ''
  }
}

export {
  FormArgument
}



// WEBPACK FOOTER //
// ./src/models/customer-good.js